import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminScope } from '../context/AdminScopeContext';

/** Blocks limited admins — super admin (scope full) only. */
const SuperAdminRouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { scope, loading, homePath } = useAdminScope();

  if (loading) {
    return null;
  }

  if (scope !== 'full') {
    return <Navigate to={homePath} replace />;
  }

  return <>{children}</>;
};

export default SuperAdminRouteGuard;
